<template>
  <BaseModal
    :is-open="isOpen" 
    title="Registrati" 
    @close="closeModal"
  >
    <div >
      <BaseInput
          id="name"
          label="Nome"
          label-position="left"
          v-model="name"
          required/>
      
      <BaseInput
          id="surname"
          label="Cognome"
          label-position="left"
          v-model="surname"
          required/>

      <BaseInput
          id="email"
          type="email"
          label="Email"
          label-position="left"
          v-model="email"
          required/>

      <BaseInput
          id="password"
          type="password"
          label="Password"
          label-position="left"
          v-model="password"
          required/>

      <div v-if="error" class="text-red-500 text-sm">{{ error }}</div>
      <div v-if="success" class="text-green-600 text-sm">Registrazione completata!</div>


    </div>
    <template #footer>
        <ActionButton
          color="green"
          type="submit"
          @click="register"
          :label="loading ? 'Registrazione...' : 'Registrati'"
          :loading="loading"
        />
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BaseInput from '../inputs/BaseInput.vue';
import ActionButton from '../buttons/ActionButton.vue';
import { registerWithCredentials } from '@/services/authService';
import type { Credentials } from '../../interfaces/Credentials';
import BaseModal from './BaseModal.vue';

const props = defineProps({
  isOpen: Boolean
});

const emit = defineEmits([ "close" ])

// Form state
const name = ref('')
const surname = ref('')
const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const success = ref(false)

const register = async () => {
  error.value = ''
  success.value = false
  loading.value = true

  try {
    const credentials: Credentials = {
      email: email.value,
      password: password.value,
      name: name.value + ' ' + surname.value
    }

    const res = await registerWithCredentials(credentials)

    if (!res.ok) {
      const { detail } = await res.json()
      throw new Error(detail || 'Errore nella registrazione')
    }

    success.value = true
    setTimeout(() => {
      closeModal();
    }, 1000)
  } catch (e: any) {
    error.value = e.message
  } finally {
    loading.value = false
  }
}

const closeModal = () => {
    emit("close");
};
</script>
